import React, { useState } from "react";
import "./FAQ.css";

const leftColumn = [
  {
    question: "What makes Glamur Paint different from other paint brands in Pakistan?",
    answer:
      "Glamur Paint stands out for its superior quality, long-lasting colours, and low-VOC eco-friendly formulations. Every product is lab-tested for durability, smoothness, and safety — ensuring professional results for every wall.",
  },
  {
    question: "Where is Glamur Paint manufactured?",
    answer:
      "Glamur Paint is proudly manufactured in Pakistan using state-of-the-art technology and high-quality raw materials to meet both local and international standards of excellence.",
  },
];

const rightColumn = [
  {
    question: "Are Glamur Paint products safe for home use?",
    answer:
      "Yes, Glamur Paint products are completely safe for home and indoor use. They are non-toxic, low-odor, and free from harmful chemicals, making them ideal for families, children, and pets.",
  },
  {
    question: "Does Glamur Paint offer both interior and exterior products?",
    answer:
      "Absolutely. Glamur Paint offers a wide range of products for both interior and exterior surfaces, including wall finishes, enamels, and weather-resistant coatings — designed to protect and beautify every space.",
  },
  {
    question: "Is Glamur Paint environmentally friendly?",
    answer:
      "Yes. Glamur Paint is formulated with low-VOC, eco-safe ingredients that reduce environmental impact while maintaining rich color depth and superior finish — helping you create a beautiful, sustainable home.",
  },
];

const FAQabout = () => {
  // ✅ First question (L0) open by default
  const [activeIndex, setActiveIndex] = useState("L0");

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const renderFAQItem = (item, index, columnPrefix) => (
    <div
      key={columnPrefix + index}
      className={`faq-item ${
        activeIndex === columnPrefix + index ? "active" : ""
      }`}
      onClick={() => toggleFAQ(columnPrefix + index)}
    >
      <div className="faq-question">
        <span className="faq-icon">
          {activeIndex === columnPrefix + index ? "–" : "+"}
        </span>
        <h3>{item.question}</h3>
      </div>
      {activeIndex === columnPrefix + index && item.answer && (
        <p className="faq-answer">{item.answer}</p>
      )}
    </div>
  );

  return (
    <section className="faq-section">
      <h2 className="faq-title">Frequently Ask Questions</h2>
      <div className="faq-columns">
        <div className="faq-column">
          {leftColumn.map((item, i) => renderFAQItem(item, i, "L"))}
        </div>
        <div className="faq-column">
          {rightColumn.map((item, i) => renderFAQItem(item, i, "R"))}
        </div>
      </div>
    </section>
  );
};

export default FAQabout;
